module.exports = __webpack_public_path__ + "img/icon-signin.8e047502.svg";